<template lang="pug">
v-container
  button.alteringCheckbox(@click="checkboxClicked" :class="boxColor")
    img.alteringCheckboxIcon(v-if="checkboxStatus === 'Y'" src="../assets/outlinedCheck.png" center)
    img.alteringCheckboxIcon(v-else-if="checkboxStatus === 'N'" src="../assets/outlinedClose.png" center)
    img.alteringCheckboxIcon(v-else)
  span.align-self-center()  {{ label }}  
</template>

<script>
export default {
  name: "AlteringCheckbox",
  props: {
    label: String,
    value: String,
    readOnly: Boolean,
  },
  data() {
    return {
      checkboxEnum: ["Y", "N", "O"],
      checkboxStatus: "O",
      boxColor: 'white',
    };
  },
  mounted() {
    this.checkboxStatus = this.value;
    this.boxColor = this.determineColor(this.value);
  },
  watch: {
    value() {
      this.checkboxStatus = this.value;
      this.boxColor = this.determineColor(this.value);
    }
  },
  methods: {
    determineColor(status) {
      switch (status) {
        case 'Y':
          return 'green';
        case 'N':
          return 'red';
        default:
          return 'white';
      }
    },
    checkboxClicked() {
      if (this.readOnly)
        return;
      switch (this.checkboxStatus) {
        case "Y":
          this.checkboxStatus = "N";
          this.$emit('input', 'N');
          break;
        case "N":
          this.checkboxStatus = "O";
          this.$emit('input', null);
          break;
        default:
          this.checkboxStatus = "Y";
          this.$emit('input', 'Y');
          break;
      }
      this.boxColor = this.determineColor(this.checkboxStatus);
    },
  },
};
</script>

<style scoped>
.alteringCheckbox {
  width: 20px;
  height: 20px;
  outline: 1px;
  outline-style: solid;
  outline-color: black;
  min-height: 20px !important;
  min-width: 20px !important;
}
.alteringCheckboxIcon {
  position: relative;
  width: 19px;
  /* height: 19px; */
  min-height: 1px !important;
  min-width: 1px !important;
}
</style>